<script lang="ts" setup>
  import { computed, onMounted, ref, watch } from 'vue'

  import { TransitionChild, TransitionRoot } from '@headlessui/vue'
  import SpinnerDefault from '@/elements/SpinnerDefault.vue'
  import ActivityItem from '@/components/activity-feed/ActivityItem.vue'
  import { useConfigStore } from '@/stores/Config.store'
  import { useActivityFeedStore } from '@/stores'

  const activityStore = useActivityFeedStore()
  const activityRef = computed(() => activityStore.$data.toArray().toReversed())
  const prefetchDone = ref(false)

  const configStore = useConfigStore()
  const state = configStore.get('activity-feed-visible', false)
  useTitropEvents().hotkeyToggleActivityFeed.on(() => {
    state.value = !state.value
  })
  onMounted(async () => {
    if (state.value) {
      await activityStore.prefetch()
      prefetchDone.value = true
    } else {
      const stopWatcher = watch(state, async () => {
        stopWatcher()
        await activityStore.prefetch()
        prefetchDone.value = true
      })
    }
  })
</script>

<template>
  <div v-if="prefetchDone">
    <TransitionRoot
      :show="state"
      as="template">
      <TransitionChild
        as="template"
        enter="transition ease-in-out duration-300 transform"
        enter-from="translate-x-72"
        enter-to="translate-x-max"
        leave="transition ease-in-out duration-300 transform"
        leave-from="translate-x-max"
        leave-to="translate-x-72">
        <div class="max-w-[100vw] w-full md:min-w-72 flow-root md:flex-none top-0 right-0 sm:max-w-72 overflow-y-auto md:border-l md:border-gray-200 md:block py-4 px-4 titrop-panel">
          <ul
            v-if="prefetchDone"
            class="-mb-8"
            role="list">
            <li v-if="activityRef.length === 0">Keine aktuellen Aktivitäten</li>

            <template
              v-for="(activity, index) in activityRef"
              :key="activity.activity['@id']">
              <Transition
                :duration="2000"
                :show="true"
                enter="transition ease-in-out duration-300 transform"
                enter-from="translate-x-72"
                enter-to="translate-x-max"
                leave="transition ease-in-out duration-300 transform"
                leave-from="translate-x-max"
                leave-to="translate-x-72"
                mode="out-in">
                <ActivityItem
                  :activity="activity"
                  :first="index !== activityRef.length - 1" />
              </Transition>
            </template>
          </ul>
          <span v-else>
            <SpinnerDefault label="Lade..." />
          </span>
        </div>
      </TransitionChild>
    </TransitionRoot>
  </div>
</template>
